import { CSSProperties, memo } from 'react'
import IconButton from '../../../Buttons/IconButton'
import NotesIcon from '../../../Icons/Notes'
import Container from '../Container'

interface NotesButtonProps {
    styleOverrides?: CSSProperties
    shadow?: boolean
    title?: string
    color?: string
    size?: number
    filled?: boolean
    tooltipPlacement?:
        | 'bottom-end'
        | 'bottom-start'
        | 'bottom'
        | 'left-end'
        | 'left-start'
        | 'left'
        | 'right-end'
        | 'right-start'
        | 'right'
        | 'top-end'
        | 'top-start'
        | 'top'
    onClick?: any
}

const NotesButton = memo((props: NotesButtonProps) => {
    const {
        styleOverrides,
        title,
        color,
        size,
        filled,
        shadow,
        tooltipPlacement,
        onClick,
    } = props
    return (
        <Container
            shadow={shadow}
            title={title}
            tooltipPlacement={tooltipPlacement}
        >
            <IconButton style={styleOverrides} onClick={onClick}>
                <NotesIcon
                    color={color ?? '#fff'}
                    size={size}
                    filled={filled}
                />
            </IconButton>
        </Container>
    )
})

export default NotesButton
